import { render, staticRenderFns } from "./BatteryDigitalSet.vue?vue&type=template&id=2dc96168&scoped=true&"
import script from "./BatteryDigitalSet.vue?vue&type=script&lang=js&"
export * from "./BatteryDigitalSet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc96168",
  null
  
)

export default component.exports